import { SitePath } from "./shared/constants";

 
 //adjust city popup visibility on page
 export const allowedCityPopupVisibilityOnPath = [
    SitePath.SELL_NOW_PAGE, 
    SitePath.ORDER_SUMMARY_PAGE,
    "sell-"

] as string[]